export default __webpack_public_path__ + "static/media/provida.a4f1e5f8.png";